module.exports = __webpack_public_path__ + "img/user-thumbnail.749bd0e4.png";